export function convertUSDToBRL(value : string){
    const formmatedValue = Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(parseFloat(value));

    return formmatedValue;
}